import * as actions from '../actions/ActionTypes';

const initialState = {
  contacts: [],
};

/**
 * Array of non obfuscated contacts
 * @param state
 * @param action
 * @return {*}
 */
const contacts = (state = initialState.contacts, action) => {
    switch (action.type) {
      case actions.GET_CONTACTS_SUCCESS:
        return action.payload.contacts;
      case actions.GET_CONTACT_DATA_SUCCESS:
        const stateSlice = [...state];
        const newState = stateSlice.map(contact => {
          if (contact.contactId === action.payload.contact.contactId) {
            return action.payload.contact;
          }
          return contact;
        })
        return newState;
      default:
        return state;
    }
  };

export default contacts;
